module.exports = __webpack_public_path__ + "img/video1.ccc90366.png";